"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APITasks = void 0;
class APITasks {
}
exports.APITasks = APITasks;
APITasks.idle = {
    isTask: true,
    key: "idle",
    template: ""
};
APITasks.any = {
    isTask: true,
    key: "any",
    template: "%s"
};
APITasks.continueAfterError = {
    isTask: true,
    key: "continueAfterError",
    template: "%s Do you want to continue?"
};
APITasks.queueStart = {
    isTask: true,
    key: "queueStart",
    template: "Starting command queue with %s items"
};
APITasks.queueFinished = {
    isTask: true,
    key: "queueFinished",
    template: "Command queue finished with %s error(s) after %s"
};
APITasks.login = {
    isTask: true,
    key: "login",
    template: "Logging in at \"%s\" as user \"%s\""
};
APITasks.logout = {
    isTask: true,
    key: "logout",
    template: "Logging out from \"%s\""
};
APITasks.readListConnectors = {
    isTask: true,
    key: "readListConnectors",
    template: "Retrieving list of connectors"
};
APITasks.readListServer = {
    isTask: true,
    key: "readListServer",
    template: "Retrieving list for \"%s\""
};
APITasks.readListLocal = {
    isTask: true,
    key: "readListLocal",
    template: "Reading local directory \"%s\""
};
APITasks.createDir = {
    isTask: true,
    key: "createDir",
    template: "Creating directory \"%s\""
};
APITasks.renameFile = {
    isTask: true,
    key: "renameFile",
    template: "Renaming file \"%s\" to \"%s\""
};
APITasks.renameDir = {
    isTask: true,
    key: "renameDir",
    template: "Renaming directory \"%s\" to \"%s\""
};
APITasks.moveFile = {
    isTask: true,
    key: "moveFile",
    template: "Moving file \"%s\" to \"%s\""
};
APITasks.moveDir = {
    isTask: true,
    key: "moveDir",
    template: "Moving directory \"%s\" to \"%s\""
};
APITasks.deleteFile = {
    isTask: true,
    key: "deleteFile",
    template: "Deleting file \"%s\""
};
APITasks.deleteDir = {
    isTask: true,
    key: "deleteDir",
    template: "Deleting directory \"%s\""
};
APITasks.copyFile = {
    isTask: true,
    key: "copyFile",
    template: "Copying file \"%s\" to \"%s\""
};
APITasks.copyDir = {
    isTask: true,
    key: "copyDir",
    template: "Copying directory \"%s\" to \"%s\""
};
APITasks.startQueueCommand = {
    isTask: true,
    key: "startQueueCommand",
    template: "Run queue command %s/%s: \"%s\""
};
APITasks.readSubDir = {
    isTask: true,
    key: "readSubDir",
    template: "Reading subdirectory \"%s\" at level %s"
};
APITasks.getMetaData = {
    isTask: true,
    key: "getMetaData",
    template: "Loading meta data for \"%s\""
};
APITasks.setMetaData = {
    isTask: true,
    key: "setMetaData",
    template: "Saving meta data for %s \"%s\", data: \"%s\""
};
APITasks.logBatchContent = {
    isTask: true,
    key: "logBatchContent",
    template: "Dumping current batch entries"
};
APITasks.logBatchContentSummary = {
    isTask: true,
    key: "logBatchContentSummary",
    template: "Dumping current batch content summary"
};
APITasks.skipping = {
    isTask: true,
    key: "skipping",
    template: "Skipping \"%s\""
};
APITasks.reImportFile = {
    isTask: true,
    key: "reImportFile",
    template: "Asking server to re-import file \"%s\""
};
APITasks.reImportDir = {
    isTask: true,
    key: "reImportDir",
    template: "Asking server to re-import directory \"%s\""
};
APITasks.queueContentSummary = {
    isTask: true,
    key: "queueContentSummary",
    template: "Current queue content:"
};
APITasks.skipDirNote = {
    isTask: true,
    key: "skipDirNote",
    template: "Skipping directories with depth > %s."
};
APITasks.skipDir = {
    isTask: true,
    key: "skipDir",
    template: "Skipping subdirectories of \"%s\" with depth > %s"
};
APITasks.skipInternalConnector = {
    isTask: true,
    key: "skipInternalConnector",
    template: "Skipping content of internal connector \"%s\", because list option \"readInternalConnectors\" is not \"true\""
};
APITasks.skipConnectorType = {
    isTask: true,
    key: "skipConnectorType",
    template: "Skipping content of  \"%s\", because connector type \"%s\" is not allowed by list option \"validConnectorTypes\""
};
APITasks.skipDirBlackList = {
    isTask: true,
    key: "skipDirBlackList",
    template: "Skipping directory \"%s\" (blacklist)."
};
APITasks.queueEmpty = {
    isTask: true,
    key: "queueEmpty",
    template: "The queue item list does not contain any entries."
};
APITasks.addEntries = {
    isTask: true,
    key: "addEntries",
    template: "Adding %s entries to list"
};
APITasks.addingEntry = {
    isTask: true,
    key: "addingEntry",
    template: "Adding entry %s/%s: \"%s\""
};
APITasks.addingEntryList = {
    isTask: true,
    key: "addingEntryList",
    template: "Adding list %s/%s for \"%s\""
};
APITasks.downloadFile = {
    isTask: true,
    key: "downloadFile",
    template: "Downloading \"%s\""
};
APITasks.preparingFile = {
    isTask: true,
    key: "preparingFile",
    template: "Preparing \"%s\""
};
APITasks.uploadFile = {
    isTask: true,
    key: "uploadFile",
    template: "Uploading \"%s\""
};
APITasks.batchDownload = {
    isTask: true,
    key: "batchDownload",
    template: "Downloading %s files to \"%s\""
};
APITasks.batchDownloadBrowser = {
    isTask: true,
    key: "batchDownloadBrowser",
    template: "Preparing %s files for download"
};
APITasks.batchUpload = {
    isTask: true,
    key: "batchUpload",
    template: "Uploading %s files to \"%s\""
};
APITasks.batchRename = {
    isTask: true,
    key: "batchRename",
    template: "Renaming %s items"
};
APITasks.batchMove = {
    isTask: true,
    key: "batchMove",
    template: "Moving %s items"
};
APITasks.batchReImport = {
    isTask: true,
    key: "batchReImport",
    template: "Reimporting %s items"
};
APITasks.batchGetMateData = {
    isTask: true,
    key: "batchGetMateData",
    template: "Get meta data of %s items"
};
APITasks.batchSetMetaData = {
    isTask: true,
    key: "batchSetMetaData",
    template: "Saving meta data of %s items"
};
APITasks.batchDelete = {
    isTask: true,
    key: "batchDelete",
    template: "Deleting %s items"
};
APITasks.batchCopy = {
    isTask: true,
    key: "batchCopy",
    template: "Copying %s items"
};
APITasks.readDataTransfer = {
    isTask: true,
    key: "readDataTransfer",
    template: "Collecting files"
};
APITasks.processFile = {
    isTask: true,
    key: "processFile",
    template: "Processing file \"%s\""
};
APITasks.skipDownload = {
    isTask: true,
    key: "skipDownload",
    template: "Skipping download, because file \"%s\" already exists (set options.overwriteExisting:true to overwrite)"
};
APITasks.skipUpload = {
    isTask: true,
    key: "skipUpload",
    template: "Skipping upload, because file \"%s\" already exists (set options.overwriteExisting:true to overwrite)"
};
APITasks.skipUploadDir = {
    isTask: true,
    key: "skipUploadDir",
    template: "Skipping directory \"%s\" (it already exists)"
};
APITasks.skipUploadDirFlatten = {
    isTask: true,
    key: "skipUploadDirFlatten",
    template: "Skipping directory \"%s\" (options.flattenTargetPath is set)"
};
APITasks.overwriteTargetFile = {
    isTask: true,
    key: "overwriteTargetFile",
    template: "The file \"%s\" already exists. Overwrite?"
};
APITasks.overwriteTargetDirectory = {
    isTask: true,
    key: "overwriteTargetDirectory",
    template: "The directory \"%s\" already exists. Overwrite?"
};
APITasks.waitDownload = {
    isTask: true,
    key: "waitDownload",
    template: "Waiting for server to create archive \"%s\""
};
APITasks.sendPlainPassword = {
    isTask: true,
    key: "sendPlainPassword",
    template: "The server requested an unencrypted password.<br/>You are currently <b>not using an SSL secured " +
        "connection</b>.<br/><br/>Do you want to continue anyway and send an <b>unencrypted password</b>?;"
};
APITasks.batchSendServiceCommands = {
    isTask: true,
    key: "batchSendServiceCommands",
    template: "Sending command \"%s\" to %s %s items"
};
APITasks.sendServiceCommand = {
    isTask: true,
    key: "sendServiceCommand",
    template: "Sending command \"%s\" to %s \"%s\""
};
APITasks.changePassWord = {
    isTask: true,
    key: "changePassWord",
    template: "Setting a new password for user \"%s\""
};
APITasks.changeUser = {
    isTask: true,
    key: "changeUser",
    template: "Changing current user to \"%s\""
};
APITasks.getUserList = {
    isTask: true,
    key: "getUserList",
    template: "Loading user list"
};
